/* eslint-disable guard-for-in */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useParams } from 'react-router';
// import { enviroment } from '@utils/config';
import {
  useCallback, useEffect, useState,
} from 'react';
// import { useSelector, useDispatch } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
// import createTokenProvider from '@utils/auth/createTokenProvider';

import devicesApi from '@api/devicesApi';
import { useTranslation } from 'react-i18next';
import telemetryApi from '@api/telemetryApi';
import telemetryActions from '../../state/telemetry/actions';

const granularityNew = [
  { name: 'Detalle', value: 'minute' },
  { name: 'Hour', value: 'hour' },
  { name: 'Day', value: 'day' },
  { name: 'Month', value: 'month' },
  { name: 'Year', value: 'year' },
];

function useGraficasDispositivoVariable() {

  const { t } = useTranslation();
  const history = useHistory();
  const BreadcrumbTitle = t('menu_items.main.general_board');
  const { device } = useParams();
  const dispatch = useDispatch();

  const [dataDevice, setDataDevice] = useState(null);
  const [deviceBusinessType, setDeviceBusinessType] = useState('');

  const [loading, setLoading] = useState(true);

  const [infoDevice, setInfoDevice] = useState(null);
  const [deviceAllInfo, setDeviceAllInfo] = useState({});
  const [deviceType, setDeviceType] = useState({});
  const [deviceField, setDeviceField] = useState(null);
  const [variableField, setVariableField] = useState([]);
  const [optionVariableField, setOptionVariableField] = useState([]);

  const today = moment();
  const [modePicker, setModePicker] = useState('day');
  const [modePickerFormat, setModePickerFormat] = useState('YYYY-MM-DD');
  const [datePicker, setDatePicker] = useState([today, today]);

  const [defaultGranularity, setDefaultGranularity] = useState(granularityNew[1].value);

  const loadingFn = async (status) => {

    setLoading(status);

  };

  const consultaApi = async () => {

    setDeviceField(null);
    setOptionVariableField([]);
    setVariableField([]);

    const abortC = new AbortController();
    const { signal } = abortC;

    await devicesApi.getDeviceId({ signal, id: device }).then((data) => {

      setDeviceAllInfo(data);
      setInfoDevice(data?.gateway?.mac);

      setDeviceType(data.device_types);

      if (data.device_types.length > 0) {

        setDeviceField(data.device_types[0].id);

      } else {

        setDeviceField(null);
        setOptionVariableField([]);
        setVariableField([]);

      }

    }).catch((error) => {

      console.log('consultaApi :: error', error.data);

    });

  };

  const consultaApiField = async () => {

    setOptionVariableField([]);
    setVariableField([]);
    loadingFn(true);

    const abortC = new AbortController();
    const { signal } = abortC;

    const data = await telemetryApi.getAllDeviceField({ signal, device_type: deviceField });

    if (data.length > 0 && deviceField != null) {

      // select variables Field
      const arrSelectVariablesField = data.map((item) => ({
        label: `${item.name} [${item.edge_name}]`,
        value: item.edge_name,
      }));
      setOptionVariableField(arrSelectVariablesField);

      let variablesValid = [];
      if (variableField.length > 0) {

        variablesValid = [...variableField];

      } else {

        variablesValid = [arrSelectVariablesField[0].value];

      }

      setVariableField(variablesValid);

    } else {

      setOptionVariableField([]);
      setVariableField([]);

    }

    loadingFn(false);

    return false;

  };

  const changeModePicker = (e) => {

    setDefaultGranularity(e);

    if (e === 'day') {

     setModePicker('day');
     setModePickerFormat('YYYY-MM-DD');

   } else if (e === 'month') {

     setModePicker('month');
     setModePickerFormat('YYYY-MM');

   } else if (e === 'year') {

     setModePicker('year');
     setModePickerFormat('YYYY');

   } else {

     setModePicker('day');
     setModePickerFormat('YYYY-MM-DD');

   }

  };

  const infoDeviceD = useCallback((deviceId) => {

    const abortC = new AbortController();
    const { signal } = abortC;

    devicesApi.getDeviceId({ signal, id: deviceId }).then((data) => {

      setDeviceBusinessType(data?.business_type);
      setDataDevice(data);

      const arrDevicesType = data.device_types.map((item) => item.name) || [];

      const itemDevice = {
        client: data.client,
        name: data.name,
        mac: data?.gateway?.mac || '',
        business: data?.business_type?.name || '',
        gateway: data?.gateway?.name || '',
        slvId: data?.slvId || '',
        firmware: data?.firmware || '',
        device_types: arrDevicesType.join(', '),
      };

      console.log('itemDevice ', itemDevice);

      dispatch(telemetryActions.setGeneralDeviceInfo(itemDevice));

    }).catch((error) => {

      console.log('getDeviceId :: error', error);

    });

  }, [dispatch]);

  const handleDeviceHome = () => {

    history.push(`/tablero-devices/${deviceBusinessType.id}`);

  };

  useEffect(() => {

    infoDeviceD(device);

    if (device !== '') {

      consultaApi();

}

  }, [device]);

  useEffect(() => {

    if (infoDevice !== null && deviceField !== null && defaultGranularity !== null) {

      consultaApiField();

    }

  }, [deviceField, defaultGranularity, datePicker]);

  return {
    device,
    dataDevice,
    deviceBusinessType,
    BreadcrumbTitle,
    handleDeviceHome,
    deviceAllInfo,
    deviceType,
    deviceField,
    setDeviceField,

    loading,

    datePicker,
    modePicker,
    modePickerFormat,
    setDatePicker,

    granularityNew,
    defaultGranularity,
    changeModePicker,

    optionVariableField,
    variableField,
    setVariableField,

  };

}

export default useGraficasDispositivoVariable;
